export const ADMIN_COMPANY_TAG_LABEL = "Admin Tags"

export const adminCompanyTagColors = {
  pillBackground: "#fee2e2",
  pillHoverBackground: "#fecaca",
  iconColor: "#b91c1c",
  badgeBackground: "#fee2e2",
} as const
